import React from 'react'

interface Props {
    quantity: number;
    label?: string;
    labelVisible?: boolean;
    disabled?: boolean;
    handleQuantityChange: (val: number) => void;
}

export default function QuantityModifier({ quantity, label, labelVisible = false, disabled = false, handleQuantityChange }: Props) {

    const quantityChange = (val: number) => (e: any) => {
        if (!disabled && val >= 1) {
            handleQuantityChange(val);
        }
    }

    return (
        <>
            {labelVisible && (
                <label className="block mb-2 font-bold text-secondary text-xs uppercase">{label}</label>
            )}
            <div className={`inline-block ${disabled ? "opacity-50" : ""} `}>
                <div className="flex overflow-hidden">
                    <QtyButton onClick={quantityChange(quantity - 1)}>-</QtyButton>
                    <input
                        value={quantity}
                        disabled={disabled}
                        className="bg-transparent border-2 border-secondary w-20 font-extrabold flex text-center items-center mx-2"
                        readOnly
                        aria-label="Quantity"
                    />
                    <QtyButton onClick={quantityChange(quantity + 1)}>+</QtyButton>
                </div>
            </div>
        </>
    );
}

const QtyButton = ({ children, onClick }: any) => (
    <button
        className="h-10 w-8 border-2 border-secondary text-secondary"
        onClick={onClick}
    >
        {children}
    </button>
)
